import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Layout from '../../components/layouts/Main';
import PackagingMaterialCard from '../../components/packagingMaterial/PackagingMaterialCard';
import PackagingMaterialModal from '../../components/packagingMaterial/PackagingMaterialModal';
import { Button, Row, Col } from 'react-bootstrap';
import config from '../../config';
import { PulseLoader } from 'react-spinners';

function PackagingMaterialPage() {
  const [materials, setMaterials] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchMaterials = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${config.API_BASE_URL}/packing-materials`);
      setMaterials(res.data);
    } catch (err) {
      console.error('Failed to fetch packaging materials', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMaterialAdded = () => {
    setShowAddModal(false);
    fetchMaterials();
  };

  useEffect(() => {
    fetchMaterials();
  }, []);

  return (
    <Layout>
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="mb-3">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
          <li className="breadcrumb-item active">Packaging Material</li>
        </ol>
      </nav>

      {/* Header */}
      <Row className="mb-3">
        <Col>
          <h2>Packaging Materials <span className="text-muted">({materials.length})</span></h2>
        </Col>
        <Col className="text-end">
          <Button onClick={() => setShowAddModal(true)}>+ Add Packaging Material</Button>
        </Col>
      </Row>

      {/* Loading Indicator */}
      {isLoading ? (
        <PulseLoader color="#014b7cbb" size={9} />
      ) : (
        <Row xs={1} sm={2} xl={3} xxl={4} className="g-3 mb-3">
          {materials.map(material => (
            <PackagingMaterialCard
              key={material._id}
              material={material}
              onUpdated={fetchMaterials}
            />
          ))}
        </Row>
      )}

      {/* Add Modal */}
      <PackagingMaterialModal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        onUpdated={handleMaterialAdded}
        isEdit={false}
      />
    </Layout>
  );
}

export default PackagingMaterialPage;
